import React from 'react';
import { Trans } from 'react-i18next';
import useTranslation from './useTranslation';

declare interface ErrorType {
  msg?: string | React.ReactNode;
  key?: string | React.ReactNode;
  code?: string | number | React.ReactNode;
}

export default function useShowError() {
  const { translateText } = useTranslation();
  const showError = ({ key, code, msg }: ErrorType) => {
    if (key) {
      return (
        <Trans i18nKey={`${key}`} values={{ inputCode: code }}>
          {msg}
        </Trans>
      );
    }
    if (msg) {
      return translateText(msg?.toString());
    }
    return null;
  };

  return { showError };
}
